export const tableInitialVariables = {
    limit: 20,
    offset: 0,
    order_by: {
        id: "asc",
    },
    where: {},
}
